<template lang="pug">
.loading
  <h1>LOADING</h1>
</template>

<script>
export default {
  mounted () {
    window.tpxHighLevelBasketInitialise()
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/loading.vue